// extracted by mini-css-extract-plugin
export default {"inputTitle":"Input_inputTitle__+ZB74"};